/**
 * Document Context Component
 *
 * Main component for bound documents with tabbed interface.
 * Tabs: Chat | Dados
 */

import { useState } from "react";
import {
  Tab,
  TabList,
  SelectTabData,
  SelectTabEvent,
} from "@fluentui/react-components";
import {
  DocumentBulletList24Regular,
  Chat24Regular,
} from "@fluentui/react-icons";

import { Documento } from "../../types";
import { ProcessDataTab, ChatTab } from "./tabs";

interface Props {
  documento?: Documento | null;
  onStatusChange?: (documento: Documento) => void;
}

type TabValue = "dados" | "chat";

export function DocumentContext({ documento, onStatusChange }: Props) {
  const [selectedTab, setSelectedTab] = useState<TabValue>("chat");

  function handleTabSelect(_: SelectTabEvent, data: SelectTabData) {
    setSelectedTab(data.value as TabValue);
  }

  return (
    <div className="taskpane">
      {/* Tab Navigation */}
      <div className="tab-container">
        <TabList
          selectedValue={selectedTab}
          onTabSelect={handleTabSelect}
          size="small"
          appearance="subtle"
        >
          <Tab value="chat" icon={<Chat24Regular />}>
            Chat
          </Tab>
          {documento && (
            <Tab value="dados" icon={<DocumentBulletList24Regular />}>
              Dados
            </Tab>
          )}
        </TabList>
        <img src="/assets/logo.png" alt="Oliveira e Olivi" className="tab-logo" />
      </div>

      {/* Tab Content - All tabs stay mounted to preserve state during AI operations */}
      <div className="tab-content">
        <div style={{ display: selectedTab === "chat" ? "block" : "none" }}>
          <ChatTab documento={documento} />
        </div>
        {documento && onStatusChange && (
          <div style={{ display: selectedTab === "dados" ? "block" : "none" }}>
            <ProcessDataTab
              documento={documento}
              onStatusChange={onStatusChange}
            />
          </div>
        )}
      </div>
    </div>
  );
}
